export default __webpack_public_path__ + "static/media/0014.17820f4b.WAV";